import * as React from 'react';
import { DateFilter } from '../DateFilter';
import { Loader } from '../Loader';
import { injectIntl, useIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RenderElement = ({
  props,
  activeTab,
  options
}) => {
  const returnObj = options?.length ? options.filter(i => i.value === activeTab) : [];
  if (props?.children?.length) {
    const isVal = props.children.filter(i => i.key === activeTab);
    const isIndex = props.children.findIndex(i => i.key === activeTab);
    if (isVal?.length) {
      return /*#__PURE__*/_jsx("div", {
        className: "kc-ui-tab-renderer",
        children: props.children[isIndex].props.children(returnObj, activeTab)
      }, activeTab);
    } else {
      return /*#__PURE__*/_jsx("div", {});
    }
  } else if (props?.children && props?.children?.key === activeTab) {
    return /*#__PURE__*/_jsx("div", {
      className: "kc-ui-tab-renderer",
      children: props.children.props.children(returnObj, activeTab)
    }, activeTab);
  } else {
    return /*#__PURE__*/_jsx("div", {});
  }
};
const _TabWidget = props => {
  const {
    loader,
    disabled,
    options,
    basePath,
    onTriggerChange,
    dateFilterTitle,
    dateFilter,
    dateFilterOptions,
    dateFilterValue,
    onTriggerDateFilterChange,
    dateFilterDateFormat
  } = props;
  const [activeTab, setActiveTab] = React.useState('');
  const intl = useIntl();
  React.useEffect(() => {
    const pathName = window.location.pathname;
    const splitFromBasePath = pathName.split(basePath);
    const activeTabValue = splitFromBasePath && splitFromBasePath.length && splitFromBasePath[splitFromBasePath.length - 1] !== "/" ? splitFromBasePath[splitFromBasePath.length - 1].replace('/', '') : options.length ? options[0].value : "";
    setActiveTab(activeTabValue);
  }, [options]);
  const onTabChange = option => {
    setActiveTab(option.value);
    if (onTriggerChange) {
      onTriggerChange({
        data: option
      });
    }
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-tab ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [/*#__PURE__*/_jsx("div", {
          className: "kc-ui-tab-header",
          children: /*#__PURE__*/_jsx("ul", {
            children: options?.map((option, index) => {
              const {
                show = true
              } = option;
              if (!show) {
                return /*#__PURE__*/_jsx("li", {});
              }
              return /*#__PURE__*/_jsx("li", {
                title: option.title ? intl.formatMessage({
                  id: option.tooltip || option.title
                }) : '',
                children: /*#__PURE__*/_jsx("a", {
                  href: "javascript:void(0)",
                  className: `${activeTab === option.value ? 'active' : ''} ${option.disabled ? 'kc-ui-disabled' : ''}`,
                  onClick: () => activeTab === option.value ? null : onTabChange(option),
                  children: /*#__PURE__*/_jsx(TranslateText, {
                    id: option.title
                  })
                })
              }, index);
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "kc-ui-tab-datefilter kc-ui-datefilter-div",
          children: dateFilter && /*#__PURE__*/_jsx(DateFilter, {
            title: dateFilterTitle,
            options: dateFilterOptions,
            value: dateFilterValue,
            onTriggerChange: onTriggerDateFilterChange,
            dateFormat: dateFilterDateFormat
          })
        }), /*#__PURE__*/_jsx(RenderElement, {
          props: props,
          activeTab: activeTab,
          options: options
        }), loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : null]
      })
    })
  });
};
_TabWidget.defaultProps = {
  loader: false,
  disabled: false,
  basePath: '',
  options: [],
  onTriggerChange: () => {},
  dateFilterTitle: '',
  dateFilter: false,
  dateFilterOptions: [],
  onTriggerDateFilterChange: () => {},
  dateFilterValue: {},
  dateFilterDateFormat: "MM/dd/yyyy"
};
export const TabWidget = injectIntl( /*#__PURE__*/React.memo(_TabWidget));